import ApiService from '../apiservice';

class LodgeRoleService extends ApiService {

    constructor() {
        super('/lodgerole');
    }

    getAll() {
        return this.get(`${this.apiurl}/all`);
    }

    getById(id) {
        return this.get(`${this.apiurl}/${id}`);
    }

    getByDescription(description) {
        return this.get(`${this.apiurl}/description/${description}`);
    }

    new(lodgeRole) {
        return this.post(`${this.apiurl}/new`, lodgeRole);
    }

}

export default LodgeRoleService;